import { importProvidersFrom } from '@angular/core';
import { Routes } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { CompanyLandingPageComponent } from './company-landing-page/company-landing-page.component';

const markdownProviders = [importProvidersFrom(MarkdownModule.forRoot())];

export const routes: Routes = [
  { path: '', component: CompanyLandingPageComponent, pathMatch: 'full', data: { page: 'home', titleKey: 'SCN.SEO.HOME_TITLE' }, providers: markdownProviders },

  {
    path: 'kostenlos-starten',
    loadComponent: () => import('./paid-landing-page/paid-landing-page.component').then((m) => m.PaidLandingPageComponent),
    data: {
      lang: 'de',
      title: 'Kostenlos starten | Scanafy',
      description: 'Erstellen Sie Ihren kostenlosen Scanafy Account und digitalisieren Sie bis zu 3 Immobilien kostenlos.',
      canonicalPath: '/kostenlos-starten',
      alternatePath: '/start-free',
      variant: 'kostenlos-starten-v1'
    }
  },
  {
    path: 'start-free',
    loadComponent: () => import('./paid-landing-page/paid-landing-page.component').then((m) => m.PaidLandingPageComponent),
    data: {
      lang: 'en',
      title: 'Start free | Scanafy',
      description: 'Create your free Scanafy account and digitize up to 3 properties for free.',
      canonicalPath: '/start-free',
      alternatePath: '/kostenlos-starten',
      variant: 'start-free-v1'
    }
  },

  // German marketing routes
  { path: 'produkt', component: CompanyLandingPageComponent, data: { page: 'product', lang: 'de', titleKey: 'SCN.SEO.PRODUCT_TITLE' }, providers: markdownProviders },
  { path: 'preise', component: CompanyLandingPageComponent, data: { page: 'pricing', lang: 'de', titleKey: 'SCN.SEO.PRICING_TITLE' }, providers: markdownProviders },
  { path: 'kunden', component: CompanyLandingPageComponent, data: { page: 'customers', lang: 'de', titleKey: 'SCN.SEO.CUSTOMERS_TITLE' }, providers: markdownProviders },
  { path: 'ressourcen', component: CompanyLandingPageComponent, data: { page: 'resources', lang: 'de', titleKey: 'SCN.SEO.RESOURCES_TITLE' }, providers: markdownProviders },
  { path: 'kontakt', component: CompanyLandingPageComponent, data: { page: 'contact', lang: 'de', titleKey: 'SCN.SEO.CONTACT_TITLE' }, providers: markdownProviders },
  { path: 'impressum', component: CompanyLandingPageComponent, data: { page: 'impressum', lang: 'de', titleKey: 'SCN.SEO.IMPRINT_TITLE' }, providers: markdownProviders },
  { path: 'datenschutz', component: CompanyLandingPageComponent, data: { page: 'datenschutz', lang: 'de', titleKey: 'SCN.SEO.PRIVACY_TITLE' }, providers: markdownProviders },
  { path: 'agb', component: CompanyLandingPageComponent, data: { page: 'agb', lang: 'de', titleKey: 'SCN.SEO.TERMS_TITLE' }, providers: markdownProviders },
  { path: 'schilderbestellbedingungen', component: CompanyLandingPageComponent, data: { page: 'sign-order-terms', lang: 'de', titleKey: 'SCN.SEO.SIGN_ORDER_TERMS_TITLE' }, providers: markdownProviders },

// English marketing routes
  { path: 'product', component: CompanyLandingPageComponent, data: { page: 'product', lang: 'en', titleKey: 'SCN.SEO.PRODUCT_TITLE' }, providers: markdownProviders },
  { path: 'pricing', component: CompanyLandingPageComponent, data: { page: 'pricing', lang: 'en', titleKey: 'SCN.SEO.PRICING_TITLE' }, providers: markdownProviders },
  { path: 'customers', component: CompanyLandingPageComponent, data: { page: 'customers', lang: 'en', titleKey: 'SCN.SEO.CUSTOMERS_TITLE' }, providers: markdownProviders },
  { path: 'resources', component: CompanyLandingPageComponent, data: { page: 'resources', lang: 'en', titleKey: 'SCN.SEO.RESOURCES_TITLE' }, providers: markdownProviders },
  { path: 'contact', component: CompanyLandingPageComponent, data: { page: 'contact', lang: 'en', titleKey: 'SCN.SEO.CONTACT_TITLE' }, providers: markdownProviders },
  { path: 'legal-notice', component: CompanyLandingPageComponent, data: { page: 'impressum', lang: 'en', titleKey: 'SCN.SEO.IMPRINT_TITLE' }, providers: markdownProviders },
  { path: 'privacy', component: CompanyLandingPageComponent, data: { page: 'datenschutz', lang: 'en', titleKey: 'SCN.SEO.PRIVACY_TITLE' }, providers: markdownProviders },
  { path: 'terms', component: CompanyLandingPageComponent, data: { page: 'agb', lang: 'en', titleKey: 'SCN.SEO.TERMS_TITLE' }, providers: markdownProviders },
  { path: 'sign-order-terms', component: CompanyLandingPageComponent, data: { page: 'sign-order-terms', lang: 'en', titleKey: 'SCN.SEO.SIGN_ORDER_TERMS_TITLE' }, providers: markdownProviders },

  // Existing app/demo and docs routes
  {
    path: 'landing-page/:companyId/:propertyId',
    loadComponent: () => import('./landing-page/landing-page.component').then((m) => m.LandingPageComponent),
    providers: markdownProviders
  },
  {
    path: 'docs',
    loadComponent: () => import('./docs/docs.component').then((m) => m.DocsComponent),
    providers: markdownProviders,
    children: [
      {
        path: '',
        loadComponent: () => import('./docs/article-view.component').then((m) => m.ArticleViewComponent),
        pathMatch: 'full'
      },
      {
        path: ':slug',
        loadComponent: () => import('./docs/article-view.component').then((m) => m.ArticleViewComponent)
      }
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./not-found/not-found.component').then((m) => m.NotFoundComponent),
    providers: markdownProviders
  }
];
